import { Button } from "antd";
import { saveAs } from "file-saver";
import React from "react";
import * as XLSX from "xlsx";

/** Format salary to 2 decimal places for export. Handles null, undefined, and invalid numbers. */
const formatSalaryForExport = (salary) => {
  const n = Number(salary);
  if (salary == null || Number.isNaN(n)) return "";
  return n.toFixed(2);
};

const ExportEmployees = ({ employees }) => {
  const exportToExcel = () => {
    const workBook = XLSX.utils.book_new();
    const workSheet = XLSX.utils.json_to_sheet(
      employees.map((employee) => ({
        "Nombre": employee.name,
        "CUIL": employee.cuil,
        "DNI": employee.dni,
        "Email": employee.email,
        "Teléfono": employee.phoneNumber,
        "Salario": formatSalaryForExport(employee.salary),
        "Compañía": employee.company.name
      }))
    );

    // Paso 2: Agregar la hoja de trabajo al libro de trabajo
    XLSX.utils.book_append_sheet(workBook, workSheet, "Empleados");

    // Paso 3: Generar el archivo Excel y descargarlo
    const excelBuffer = XLSX.write(workBook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Empleados.xlsx");
  };

  return (
    <Button onClick={exportToExcel} type="primary">
      Exportar a Excel
    </Button>
  );
};

export default ExportEmployees;
